import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';

export type ConnectionAttemptBannerVariant =
  | 'reauth-credentials'
  | 'reauth-auth-interaction'
  | 'failed-retry';

@Component({
  selector: 'lib-connection-attempt-banner',
  imports: [CommonModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './connection-attempt-banner.component.html',
  styleUrl: './connection-attempt-banner.component.scss',
})
export class ConnectionAttemptBannerComponent {
  @Input({ required: true }) variant: ConnectionAttemptBannerVariant =
    'reauth-auth-interaction';
  @Input() integrationEnabled = false;
  @Input() integrationEntityName = '';
  @Input() customMessage: string | null = null;

  get integrationSuffix(): string {
    return this.integrationEnabled ? '_integration' : '';
  }

  get titleKey(): string {
    switch (this.variant) {
      case 'failed-retry':
        return 'lang.connection_attempt_banner_failed_title';
      default:
        return 'lang.connection_attempt_banner_reauth_title';
    }
  }

  get messageKey(): string | null {
    if (this.customMessage) {
      return null;
    }

    switch (this.variant) {
      case 'reauth-credentials':
        return `lang.connection_attempt_banner_reauth_credentials_message${this.integrationSuffix}`;
      case 'reauth-auth-interaction':
        return `lang.connection_attempt_banner_reauth_auth_interaction_message${this.integrationSuffix}`;
      case 'failed-retry':
        return 'lang.connection_attempt_banner_failed_fallback_message';
    }
  }
}
